import { useAxios } from '@/composables/useAxios';
import type { AuthResponse, ApiResponse, IUser } from '@/types/models';
import type { AppException, ResponseMessage } from '@/types/common';
import type {
  ForgotPasswordRequest,
  LoginRequest,
  SingupRequest,
  SocialLoginPayload,
} from '@/types/dto';
export default () => {
  const { callAxios, callAxiosProcess } = useAxios();
  const singin = async (
    loginRequest: LoginRequest,
  ): Promise<ApiResponse<AuthResponse> | null> => {
    return await callAxios<ApiResponse<AuthResponse>>({
      API: '/api/v1/auth/sign_in',
      method: 'POST',
      body: loginRequest,
    });
  };

  const signinSocial = async (
    endpoint: string,
    loginSocialRequest: SocialLoginPayload,
  ): Promise<ApiResponse<AuthResponse> | null> => {
    return await callAxios<ApiResponse<AuthResponse>>({
      API: endpoint,
      method: 'POST',
      body: loginSocialRequest,
    });
  };

  const singup = async (
    signupRequest: SingupRequest,
  ): Promise<ApiResponse<AuthResponse> | null> => {
    return await callAxios<ApiResponse<AuthResponse>>({
      API: '/api/v1/auth/sign_up',
      method: 'POST',
      body: signupRequest,
    });
  };
  // Forgot password
  const requestVerifyCodeToResetPwd = async (
    req: ForgotPasswordRequest,
  ): Promise<ApiResponse | AppException | null> => {
    return await callAxios<ApiResponse | AppException>({
      API: '/api/v1/auth/forgot-password',
      method: 'POST',
      body: {
        email: req.email,
      },
    });
  };
  // const sendVerifyCodeToResetPwd = async (
  //   req: ForgotPasswordRequest
  // ): Promise<AxiosResponse<ResponseMessage | AppException> | null> => {
  //   return await callAxiosProcess<ResponseMessage | AppException>({
  //     API: '/api/auth/sendVerifyCodeToResetPwd',
  //     method: 'POST',
  //     body: {
  //       forgotPasswordRequest: req
  //     },
  //   });
  // };
  const resetPassword = async (
    req: ForgotPasswordRequest,
  ): Promise<ApiResponse<IUser> | AppException | null> => {
    return await callAxios<ApiResponse<IUser> | AppException>({
      API: '/api/v1/auth/reset-password',
      method: 'POST',
      body: req,
    });
  };

  const loginPasscode = async (
    identifier: string,
    passcode: string,
  ): Promise<ApiResponse<AuthResponse> | AppException | null> => {
    return await callAxios<ApiResponse<AuthResponse> | AppException>({
      API: '/api/v1/auth/login-passcode',
      method: 'POST',
      body: {
        identifier,
        passcode,
      },
    });
  };

  const updatePassword = async (data: {
    currentPassword: string;
    newPassword: string;
    confirmPassword: string;
  }): Promise<ApiResponse | AppException | null> => {
    return await callAxios<ApiResponse | AppException>({
      API: '/api/v1/user/profile/password',
      method: 'PATCH',
      body: data,
    });
  };

  const updatePasscode = async (data: {
    currentPasscode: string;
    newPasscode: string;
    confirmPasscode: string;
  }): Promise<ApiResponse | AppException | null> => {
    return await callAxios<ApiResponse | AppException>({
      API: '/api/v1/auth/update-passcode',
      method: 'PUT',
      body: data,
    });
  };

  return {
    singin,
    signinSocial,
    singup,
    requestVerifyCodeToResetPwd,
    // sendVerifyCodeToResetPwd,
    resetPassword,
    loginPasscode,
    updatePassword,
    updatePasscode,
  };
};
